import Vue from 'vue';
import aboutUsTimeline from './about-us-timeline.vue';
Vue.component('about-us-timeline', aboutUsTimeline);
